import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {Item} from '../../models/policy.model';

export interface ItemsState extends EntityState<Item> {}


@Injectable({providedIn: 'root'})
export class ItemsStore extends SignalEntityStore<Item, ItemsState> {
    constructor() {
        super({name: 'items', idKey: 'id'});
    }
}
